<template>
  <div>
    <list row-key="RecordId" ref="list" unit="保税商品信息" table-max-height="535px" expand-all-row :page="page" :query-params="params"
      :show-checkbox="showCheckbox" :show-query="showQuery" :get-data-func="api.list">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">

       <el-form-item label="商品编号">
          <el-input v-model="params.FilingsOrderid" placeholder="请输入商品编号" clearable />
       </el-form-item>

        <el-form-item label="商品货号">
          <el-input v-model="params.GoodsArticleno" placeholder="请输入商品货号" clearable />
        </el-form-item>

         <el-form-item label="商品名称">
          <el-input v-model="params.FilingsName" placeholder="请输入商品名称" clearable />
        </el-form-item>

        

         <el-form-item label="类目">
          <el-input v-model="params.FilingsCategory" placeholder="请输入类目" clearable />
        </el-form-item>

         <el-form-item label="原产国">
          <el-input v-model="params.CountryName" placeholder="请输入原产国" clearable />
        </el-form-item>

        <el-form-item label="商品品牌">
          <el-select v-model="params.BrandId" placeholder="请选择商品品牌" clearable>
            <el-option v-for="(i, k) in Brands" :key="k" :label="i.BrandName" :value="i.RecordId"></el-option>
          </el-select>
        </el-form-item>
       
          <el-form-item label="计量单位">
          <el-select v-model="params.MainUnitid" placeholder="请选择计量单位" clearable>
            <el-option v-for="(i, k) in Units" :key="k" :label="i.UnitName" :value="i.RecordId"></el-option>
          </el-select>
        </el-form-item>
        

      <!--  <el-form-item label="备案状态">
            <el-select v-model="params.FilingsState" placeholder="请选择备案状态" clearable>
              <el-option label="已备案" :value="1"></el-option>
              <el-option label="未备案" :value="0"></el-option>
            </el-select>
          </el-form-item>-->
               
      </template>
      <template slot="table">
        <el-table-column prop="OrderId" label="排序号" min-width="80px" />
         <el-table-column prop="FilingsOrderid" label="商品编号" min-width="130px" />
         <el-table-column prop="FilingsName" label="商品名称" min-width="200px" />
      
        <el-table-column prop="GoodsArticleno" label="商品货号" min-width="130px" />
      <!--  <el-table-column prop="GoodsCode" label="商品编号" min-width="130px" />  -->
       
       
        <el-table-column prop="FilingsMaterialno" label="物料号" min-width="130px" />
        <el-table-column prop="FilingsCategory" label="类目" min-width="130px" />
        <el-table-column prop="BrandName" label="品牌" min-width="100px" />       
        <el-table-column prop="UnitMainname" label="计量单位" min-width="100px" />
        <el-table-column prop="UnitLegalname" label="法定单位" min-width="100px" />
        <el-table-column prop="UnitSecondname" label="第二计量单位" min-width="120px" />
        <el-table-column prop="CountryName" label="原产国" min-width="100px" />
        <el-table-column prop="TaxRate" label="税率" min-width="100px" />       
        
    <!--     <el-table-column prop="FilingsState" label="备案状态" width="100px" align="center">
            <template slot-scope="{row}">
              <el-tag v-if="row.FilingsState == 1" type="success">已备案</el-tag>
              <el-tag v-if="row.FilingsState == 0" type="danger">未备案</el-tag>
            </template>
          </el-table-column>-->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
        
      </template>
    
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
export default {
  mixins: [listMixin],
  components: { list },
  props: {
   
  },
  data() {
    return {
      api: require("@/api/goods/infobonded").default,
      brandplatform_api: require("@/api/goods/brandplatform").default,
      unitplatform_api: require("@/api/goods/unitplatform").default,
      params: {
        GoodsArticleno: "", 
        FilingsName: "", 
        CountryName: "",
        FilingsOrderid: "", 
        FilingsCategory: "", 
        BrandId: null, 
        MainUnitid: null, 
        FilingsState: null, 
       
      },
      Brands: [],
      Units: [],
    };
  },
  mounted() {
    this.brandplatform_api.list({ State: 1 }).then(res => {
      if (res.Code == 0) {
        this.Brands = res.Data;
      }
    }),
    this.unitplatform_api.list({ State: 1 }).then(res => {
      if (res.Code == 0) {
        this.Units = res.Data;
      }
    })
  },
  methods: {
   
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
     onExport() {
        this.api.export(this.params);
      },   
    
  },
};
</script>